export const classes = {
  toggleButton:
    'shrink-0 min-h-0 leading-none rounded-lg border-none px-[13px] py-[5px] text-xs font-semibold normal-case text-taupe-2 dark:text-mauve-2 aria-pressed:bg-grad aria-pressed:text-white dark:aria-pressed:bg-grad-dark dark:aria-pressed:text-white',
};

export const styles = {
  toggleButton: {
    '&.MuiToggleButtonGroup-grouped': {
      border: 'none',
      margin: 0,
      borderRadius: '8px',
    },
  },
};
